<template>
  <aside class="side_menu_wrapper">
    <div class="nav-side-menu">
      <span class="menu-item" @click="toggleMenu"> <router-link class="selected" to="/"> <i class="fa fa-home"></i>
          <span>Home</span> </router-link>
        <div class="submenu"> </div>
      </span>
      <span class="menu-item" @click="toggleMenu">
        <router-link to="/information"> <i class="fa fa-newspaper"></i>
          <span>Information</span> </router-link>
        <div class="submenu"> </div>
      </span>
      <span class="menu-item" @click="toggleMenu">
        <router-link to="/releases"> <i class="fa fa-music"></i>
          <span>Releases</span> </router-link>
        <div class="submenu"> </div>
      </span>
      <span class="menu-item" @click="toggleMenu">
        <router-link to="/hyperLink"> <i class="fab fa-youtube"></i>
          <span>HyperLink</span> </router-link>
        <div class="submenu"> </div>
      </span>
      <span class="menu-item" @click="toggleMenu">
        <router-link to="/submission"> <i class="fas fa-paper-plane"></i>
          <span>Submission</span> </router-link>
        <div class="submenu"> </div>
      </span>
      <span class="menu-item" @click="toggleMenu">
        <router-link to="/contact"> <i class="fas fa-envelope-open"></i>
          <span>Contact us</span> </router-link>
        <div class="submenu"> </div>
      </span>
      <span class="menu-item" @click="logout" v-if="$store.getters.isLoggedIn">
        <a href="javascript:0"> <i class="fas fa-sign-out-alt"></i>
          <span>Logout</span> </a>
        <div class="submenu"> </div>
      </span>
    </div>
  </aside>
</template>

<script>
import User from '@/models/User'
export default {
  name: 'Sidebar',
  data () {
    return {
      user: new User(this.$store.getters.user)
    }
  },
  methods: {
    logout () {
      if (this.$store.getters.isLoggedIn) {
        this.$store
          .dispatch('logout')
          .then(() => {
            this.toggleMenu()
            this.$router.push('/login')
            this.$toast.success('Logged out successfully')
          })
          .catch((err) => {
            console.log(err)
            this.$toast.error(err)
          })
      }
    },
    toggleMenu () {
      document.querySelector('aside').classList.toggle('active')
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue